import { useState } from 'react';
import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader, Stack, IconButton, Collapse } from '@mui/material';
// components
import Iconify from '../../../components/Iconify';
// hooks
import useLocales from '../../../hooks/useLocales';
import useAuth from '../../../hooks/useAuth';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig, isCollapse = false, ...other }) {
  const { translate } = useLocales();
  const { user } = useAuth();
  const [openGroup, setOpenGroup] = useState(Object.fromEntries(navConfig.map((_, index) => [index, true])));

  const handleToggle = (index) => {
    setOpenGroup((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  return (
    <Box {...other}>
      {navConfig.map((group, index) => (
        <List key={index} disablePadding sx={{ px: 2 }}>
          {group.subheader && (
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0,
                }),
              }}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <Box>
                  <IconButton
                    size="small"
                    onClick={() => handleToggle(index)}
                    aria-expanded={openGroup[index]}
                    aria-controls={`group-${index}`}
                  >
                    {<Iconify icon={openGroup[index] ? 'eva:chevron-up-fill' : 'eva:chevron-down-fill'} />}
                  </IconButton>
                </Box>
                <Box>{translate(typeof group.subheader === 'function' ? group.subheader(user) : group.subheader)}</Box>
              </Stack>
            </ListSubheaderStyle>
          )}
          <Collapse in={openGroup[index]} timeout="auto" unmountOnExit>
            <Box sx={{ pl: 3 }}>
              {group.items.map((list, index) => (
                <NavListRoot key={index} list={list} isCollapse={isCollapse} />
              ))}
            </Box>
          </Collapse>
        </List>
      ))}
    </Box>
  );
}
